import { People } from "@mui/icons-material";
import Button from "components/atoms/Button/Button";
import Card from "components/atoms/Card/Card"
import Modal from "components/atoms/Modal/Modal";
import useModal from "components/atoms/Modal/useModal";
import { FormattedMessage } from "react-intl";
import VideoCallParticipants from "../VideoCallParticipants/VideoCallParticipants";
import { VideoCallParticipant } from "../CreateVideoCall/useVideoCallParticipants";
import { navigateToVideoCallpageWithChannel } from "utils/history";
import { useSelectedLinkContext } from "contexts";

export type VideoCallCardProps = {
  date: Date;
  participants: VideoCallParticipant[];
  videoCallCreator: string;
  videoCallLink: string;
}

type RoomAge = {
  age: number;
  unit: string;
}

const VideoCallCard = ({ date, participants, videoCallCreator, videoCallLink }: VideoCallCardProps): JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();
  const { isModalOpened: isVideoCallParticipantsModalOpened, openModal: openVideoCallParticipantsModal, closeModal: closeVideoCallParticipantsModal } = useModal(false);
  const nbParticipants = participants.length + 1; // On ajoute la tablette
  const dateFormatter = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit' });
  const roomAgeInHours = Math.round((new Date().getTime() - date.getTime()) / 1000 / 60 / 60);

  const calcRoomAge = (): RoomAge => {
    if (roomAgeInHours > 0) {
      return roomAgeInHours === 1 ? { age: roomAgeInHours, unit: 'heure' } : { age: roomAgeInHours, unit: 'heures' };
    } 
    const roomAgeInMinutes = Math.round((new Date().getTime() - date.getTime()) / 1000 / 60);
    return roomAgeInMinutes <= 1 ? { age: 1, unit: 'minute' } : { age: roomAgeInMinutes, unit: 'minutes' };
  };

  const roomAge: RoomAge = calcRoomAge();

  const joinCall = () => {
    navigateToVideoCallpageWithChannel(selectedLink, videoCallLink);
  }

  return  <Card classname="h-full w-fit">
            <div className='flex flex-col w-fit h-full gap-2w'>
              <h1 className='text-subtitle1'>
                <FormattedMessage id='videoCall.home.videoCallList.videoCallCard.title' values={{ videoCallCreator }} />
              </h1>
              <div className='flex flex-col gap-1w mt-auto'>
                <span className='text-body2'>
                  <FormattedMessage id='videoCall.home.videoCallList.videoCallCard.invited' values={{ participantsNumber: nbParticipants }} />
                </span>
                <span className='text-overline'>
                  <FormattedMessage id='videoCall.home.videoCallList.videoCallCard.dateCreation' values={{ date: dateFormatter.format(date) }} />
                  { !(roomAgeInHours > 24) && 
                    <FormattedMessage id='videoCall.home.videoCallList.videoCallCard.dateCreationWithHours' values={{ time: roomAge.age, unit: roomAge.unit }} />
                  }
                </span>
              </div>
              <div className='flex gap-2w'>
                <People className='cursor-pointer text-classic-violet-main' onClick={openVideoCallParticipantsModal} fontSize="large" />
                <Button onClick={joinCall}><FormattedMessage id='videoCall.home.videoCallList.videoCallCard.joinCall' /></Button>
              </div>
            </div>
            {isVideoCallParticipantsModalOpened && 
              <Modal title={`Appel vidéo de ${videoCallCreator}`} onClose={closeVideoCallParticipantsModal}>
                <div className="flex flex-col gap-1w w-[350px]">
                  <VideoCallParticipants participants={participants} />
                </div>
              </Modal>
            }
          </Card>;
}

export default VideoCallCard;